import { Image } from 'antd'
import React from 'react'
import logo from "../../static/images/sochIOtLogo.jpeg"
const WelcomeScreen = () => {
    return (
        <div className="pl-2 py-2 h-full flex flex-col">
            <div className="flex flex-row justify-between pb-4">
                <div>
                    <p className="text-xl font-medium leading-[30px] text-black-1">
                        Dashboard
                    </p>
                </div>
            </div>
            <div className="h-full min-h-[78dvh] rounded-xl overflow-hidden bg-white flex-1 pb-5 min-w-full flex items-center justify-center">
                <div className="w-full h-full px-8 py-6">
                    <div className='flex w-full flex-1 h-full items-center justify-center flex-col'>
                        <Image src={logo}  alt="logo" preview={false} width={200} />
                        <h1 className='text-3xl font-bold text-black-3'>Welcome to <span className='text-primary'>SochIot</span></h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WelcomeScreen